import { render } from "./InputTextArea.vue?vue&type=template&id=0dbb4497&scoped=true&ts=true"
import script from "./InputTextArea.vue?vue&type=script&lang=ts"
export * from "./InputTextArea.vue?vue&type=script&lang=ts"

import "./InputTextArea.vue?vue&type=style&index=0&id=0dbb4497&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dbb4497"]])

export default __exports__